import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

const LoadingIndicator = ({ size = 'md', color = 'orange', fullScreen = false }) => {
  // Size mapping
  const sizeMap = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  // Color mapping
  const colorMap = {
    orange: 'border-orange-500',
    blue: 'border-blue-500',
    green: 'border-green-500',
    red: 'border-red-500',
    white: 'border-white'
  };

  // Container variants for animation
  const containerVariants = {
    animate: {
      rotate: 360,
      transition: {
        duration: 1,
        ease: "linear",
        repeat: Infinity
      }
    }
  };

  // Get the size and color classes
  const sizeClass = sizeMap[size] || sizeMap.md;
  const colorClass = colorMap[color] || colorMap.orange;

  return (
    <div className={`flex items-center justify-center ${fullScreen ? 'fixed inset-0 bg-black/50 z-50' : ''}`}>
      <motion.div
        className={`${sizeClass} rounded-full border-4 border-t-transparent ${colorClass}`}
        animate="animate"
        variants={containerVariants}
        aria-label="Loading"
      />
    </div>
  );
};

LoadingIndicator.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  color: PropTypes.oneOf(['orange', 'blue', 'green', 'red', 'white']),
  fullScreen: PropTypes.bool
};

export default LoadingIndicator; 